"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var IconShare = function IconShare(_ref) {
  var style = _ref.style,
      className = _ref.className;
  return _react.default.createElement("svg", {
    width: "16px",
    height: "16px",
    className: (0, _classnames.default)('Icon', 'IconShare', className),
    style: style,
    viewBox: "0 0 16 16"
  }, _react.default.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    d: "M15.2 11c.442 0 .8.32.8.714v2.143C16 15.041 14.925 16 13.6 16H2.4C1.075 16 0 15.04 0 13.857v-2.143C0 11.32.358 11 .8 11c.442 0 .8.32.8.714v2.143c0 .395.358.714.8.714h11.2c.442 0 .8-.32.8-.714v-2.143c0-.394.358-.714.8-.714zM8.05 0a.788.788 0 0 1 .366.092.782.782 0 0 1 .164.121L8.503.147a.75.75 0 0 1 .005.005l.072.061 3 2.91a.712.712 0 0 1 0 1.028.767.767 0 0 1-1.06 0L8.799 2.482l.001 8.427a.735.735 0 0 1-.648.72l-.102.007a.739.739 0 0 1-.75-.727l-.001-8.426L5.58 4.151a.768.768 0 0 1-.976.07l-.084-.07a.712.712 0 0 1 0-1.029l3-2.909.072-.061A.75.75 0 0 1 8.05 0l-.08.004A.778.778 0 0 1 8.033 0z"
  }));
};

var _default = IconShare;
exports.default = _default;